<template>
<fragment>
    <div class="mobile_title">{{$t('FIELD.GLOBAL.CATEGORY')}}</div>
    <dl class="dl_select">
        <dd data-input-type="select">
            <select class="slt_white w100p" :id="category1" :name="category1" v-model="selCategory1" @change="changeCategory1($event)">
                <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                <option v-show="categoryComboList1.length > 0"
                        v-for="item in categoryComboList1"
                        :key="item.code"
                        :value="item.code"
                >{{item.codeName}}</option>
            </select> 
        </dd>
    </dl>
    <dl class="dl_select">
        <dd data-input-type="select">
            <select class="slt_white w100p" :id="category2" :name="category2" v-model="selCategory2" @change="changeCategory2($event)">
                <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                <option v-show="categoryComboList2.length > 0"
                        v-for="item in categoryComboList2"
                        :key="item.code"
                        :value="item.code"
                >{{item.codeName}}</option>
            </select>
        </dd>
    </dl>
    <dl class="dl_select">
        <dd data-input-type="select">
            <select class="slt_white w100p" :id="category3" :name="category3" v-model="selCategory3" @change="changeCategory3($event)">
                <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                <option v-show="categoryComboList3.length > 0"
                        v-for="item in categoryComboList3"
                        :key="item.code"
                        :value="item.code"
                >{{item.codeName}}</option>
            </select>
        </dd>
    </dl>
</fragment>
</template>
<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import api                      from '@/service';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil }  from '@/utils';
import { EventBus }             from '@/utils/EventBus';

export default {
    name: 'CategoryComboBox',
    props: [ 'searchPRD_CATEGORY_CD1', 'searchPRD_CATEGORY_CD2', 'searchPRD_CATEGORY_CD3', 'menuGroupDetailCd', 'hhpYn' ],
    data() {
        return {
            initHtml: false,
            category1: 'searchPRD_CATEGORY_CD1',
            category2: 'searchPRD_CATEGORY_CD2',
            category3: 'searchPRD_CATEGORY_CD3',
            selCategory1: '',
            selCategory2: '',
            selCategory3: '',
            categoryComboList1: [],
            categoryComboList2: [],
            categoryComboList3: [],

            qCategory1: '',
            qCategory2: '',
            qCategory3: '',
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            userCorpCd: 'getCorpCd'
        }),
        // Search parameter props
        getSearchCatCd1() { return (!SDLUtil.isNull(this.qCategory1)) ? this.qCategory1 : this.searchPRD_CATEGORY_CD1 || ''; },
        getSearchCatCd2() { return (!SDLUtil.isNull(this.qCategory2)) ? this.qCategory2 : this.searchPRD_CATEGORY_CD2 || ''; },
        getSearchCatCd3() { return (!SDLUtil.isNull(this.qCategory3)) ? this.qCategory3 : this.searchPRD_CATEGORY_CD3 || ''; },
        getUserCorpCd() {
            return this.userCorpCd || '';
        },
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList(this.getSearchCatCd1, "ADM_CATEGORY_B").then(data => {
                this.selCategory1 = this.getSearchCatCd1;
                this.categoryComboList2 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            this.getCodeComboList(this.getSearchCatCd2, "ADM_CATEGORY_C").then(data => {
                this.selCategory2 = this.getSearchCatCd2;
                this.categoryComboList3 = data;
                this.selCategory3 = this.getSearchCatCd3;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.selCategory2 = '';
                this.categoryComboList3 = [], this.selCategory3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.selCategory2 = '';
                    this.categoryComboList2 = data;
                });
                
                this.categoryComboList3 = [], this.selCategory3 = '';
            }

            this.emitParent(e);
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.selCategory3 = '';

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.selCategory3 = '';
                    this.categoryComboList3 = data;
                });
            }

            this.emitParent(e);
        },
        // 세번째 카테고리 변경 이벤트
        changeCategory3(e) {
            this.emitParent(e);
        },
        // 모든 카테고리 변경 이벤트, 처음 Mounted 혹은, quick category 를 click 했을 때 호출
        changeCategories() {
            // Promise 를 통한 순차 실행
            this.setCategory1().then(() => {
                this.setCategory2().then(() => {
                    this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                        /*
                         * 2016.09.27 무선 유저가 아니면 무선 카테고리를 선택하지 못하도록 함 - ASIS List.jsp line 170
                         * 2020.03.30 ASIS 에서는 색상으로 선택 못하게 하였지만, TOBE에서는 카테고리에서 삭제
                         */
                        let refineData = [];
                        if( data.length > 0 ) {
                            for(let category of data) {
                                if(
                                    (
                                        this.menuGroupDetailCd == 'SB'  /*Service Bulletin*/
                                     || this.menuGroupDetailCd == 'KSBL'/*Service Bulletin (Local)*/
                                    )
                                    && this.hhpYn == 'N'
                                ) {
                                    if(category.code != 'D') {
                                        refineData.push(category);
                                    }
                                    
                                } else {
                                    refineData.push(category);
                                }
                            }
                        }
                        
                        this.categoryComboList1 = refineData;
                        this.emitParent();
                    });
                });
            });

            EventBus.$emit('select-recent-model', '');
        },
        // 카테고리 파라미터 초기화
        initCategoryParam() {
            this.qCategory1 = '';
            this.qCategory2 = '';
            this.qCategory3 = '';
            this.selCategory1 = '';
            this.selCategory2 = '';
            this.selCategory3 = '';
            this.categoryComboList1 = [];
            this.categoryComboList2 = [];
            this.categoryComboList3 = [];
        },
        // Quick Category Parameter setting
        setQuickCategoryParam(catForm) {
            this.initCategoryParam();
            this.qCategory1 = catForm.searchPRD_CATEGORY_CD1;
            this.qCategory2 = catForm.searchPRD_CATEGORY_CD2;
            this.qCategory3 = catForm.searchPRD_CATEGORY_CD3;

            this.changeCategories();
        },
        // KnowledgeSearch.vue 로 카테고리 파라미터를 전달
        emitParent(e) {
            this.$emit('categoryCode', {
                searchPRD_CATEGORY_CD1: this.selCategory1,
                searchPRD_CATEGORY_CD2: this.selCategory2,
                searchPRD_CATEGORY_CD3: this.selCategory3,
            });
        }
    },
    created() {
        EventBus.$on('quick-category', catForm => { this.setQuickCategoryParam(catForm); });
    },
    mounted() {
        this.$nextTick(() => {
            this.changeCategories();
        });
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('quick-category');
    }
};
    
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/CategoryComboBox.vue